import React from 'react';
import { AdvancedImage, lazyload, responsive } from '@cloudinary/react';
import { TextVariant } from '@naf/text';
import { useCloudinary } from '../../../../hooks/Cloudinary/useCloudinary';
import { ExternalMainEntry } from '../../../../../../types/ExternalMainEntryType';
import { StyledA, Card, ImageWrapper, Label, StyledText, UnderlinedElement } from './Styles';

export interface ExternalMainEntryCardProps {
  externalMainEntry: ExternalMainEntry;
}

export const ExternalMainEntryCard = ({ externalMainEntry: { image, data } }: ExternalMainEntryCardProps) => {
  const { getResponsiveImage } = useCloudinary();

  const mainImage = getResponsiveImage(image?.publicId, {
    format: 'svg',
    devicePR: 3.0,
    focusMethod: image?.focus,
    width: 120,
  });

  return (
    <StyledA href={data.href}>
      <Card>
        {mainImage && (
          <ImageWrapper>
            <AdvancedImage
              cldImg={mainImage}
              plugins={[lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 }), responsive({ steps: 200 })]}
              alt={image.altText || image.caption}
            />
          </ImageWrapper>
        )}
        <Label>
          <StyledText variant={TextVariant.Header3}>
            <UnderlinedElement>{data.title}</UnderlinedElement>
          </StyledText>
        </Label>
      </Card>
    </StyledA>
  );
};
